module.exports = "/assets/data/2cab14f7f7ec41f6bd2dde4bfd0cb237-LS10.data.json";